export const environment = {
  production: true,
  baseUrl: 'https://cm-dev.atlantis.gallery/api/c',
};
